import React from 'react';

const Svg = ({ size = 22, strokeWidth = 2, className, children }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

export const FillIcon = (p) => (
  <Svg {...p}>
    <path d="M19 11l-8-8-8.5 8.5a2.1 2.1 0 0 0 0 3L7 19a2.1 2.1 0 0 0 3 0L19 11z" />
    <path d="M5 2l5 5" /><path d="M2 13h15" />
    <path d="M22 20a2 2 0 1 1-4 0c0-1.6 2-4 2-4s2 2.4 2 4z" />
  </Svg>
);
export const PencilIcon = (p) => (
  <Svg {...p}><path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" /></Svg>
);
export const HandIcon = (p) => (
  <Svg {...p}>
    <path d="M18 11V6a2 2 0 0 0-4 0v5" /><path d="M14 10V4a2 2 0 0 0-4 0v6" />
    <path d="M10 10.5V6a2 2 0 0 0-4 0v8" />
    <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.9-6-2.4l-3.6-3.6a2 2 0 0 1 2.8-2.8L7 15" />
  </Svg>
);
export const UndoIcon = (p) => (
  <Svg {...p}><path d="M9 14L4 9l5-5" /><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" /></Svg>
);
export const RedoIcon = (p) => (
  <Svg {...p}><path d="M15 14l5-5-5-5" /><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13" /></Svg>
);
export const ChevronLeft = (p) => <Svg strokeWidth={2.2} {...p}><path d="M15 18l-6-6 6-6" /></Svg>;
export const ChevronRight = (p) => <Svg strokeWidth={2.2} {...p}><path d="M9 18l6-6-6-6" /></Svg>;
export const ChevronDown = (p) => <Svg strokeWidth={2.2} {...p}><path d="M6 9l6 6 6-6" /></Svg>;
export const ArrowRight = (p) => <Svg strokeWidth={2.2} {...p}><path d="M5 12h14" /><path d="M13 6l6 6-6 6" /></Svg>;
export const GridIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Svg>
);
export const DownloadIcon = (p) => (
  <Svg strokeWidth={2.2} {...p}><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></Svg>
);
export const MinusIcon = (p) => <Svg strokeWidth={2.2} {...p}><path d="M5 12h14" /></Svg>;
export const PlusIcon = (p) => <Svg strokeWidth={2.2} {...p}><path d="M5 12h14" /><path d="M12 5v14" /></Svg>;
export const EditIcon = (p) => (
  <Svg strokeWidth={2.2} {...p}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></Svg>
);
export const CheckIcon = (p) => <Svg strokeWidth={2.4} {...p}><path d="M5 12l5 5L20 7" /></Svg>;
export const CloseIcon = (p) => <Svg strokeWidth={2.2} {...p}><path d="M6 6l12 12" /><path d="M18 6L6 18" /></Svg>;
export const EraserIcon = (p) => (
  <Svg {...p}>
    <path d="M7 21l-4.3-4.3a1.5 1.5 0 0 1 0-2.1L13.6 3.7a1.5 1.5 0 0 1 2.1 0l4.6 4.6a1.5 1.5 0 0 1 0 2.1L11 20" />
    <path d="M7 21h13" /><path d="M9 11l6 6" />
  </Svg>
);
export const ResetIcon = (p) => (
  <Svg {...p}><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /></Svg>
);
